import React, { ReactNode, useRef } from 'react'
import { Field as FinalField } from 'react-final-form'
import { OnChange as FinalOnChange } from 'react-final-form-listeners'

import { useFieldContext } from '../Field'
import { TValue } from './types'

type TOnChange = {
  onChange?: (value: TValue, previousValue?: TValue | null | undefined) => void
  preventFireOnMount?: boolean
  name: string
}

const OnChange = (props: TOnChange): React.ReactElement => {
  const { onChange, preventFireOnMount, name } = props

  const refInit = useRef<boolean>()

  const { prefix } = useFieldContext()

  const fieldName = prefix ? `${prefix}.${name}` : name

  return (
    <React.Fragment>
      <FinalField name={fieldName}>
        {({ input: { value } }) => {
          if (!refInit.current) {
            refInit.current = true
            if (!preventFireOnMount && onChange) {
              onChange(value)
            }
          }
          return null
        }}
      </FinalField>
      <FinalOnChange name={name}>
        {onChange ? onChange : () => <></>}
      </FinalOnChange>
    </React.Fragment>
  )
}

export default OnChange
